export default "__VITE_ASSET__f44972be__"